import { render } from "./VPARecall.vue?vue&type=template&id=e1ea0a16&scoped=true"
import script from "./VPARecall.vue?vue&type=script&lang=js"
export * from "./VPARecall.vue?vue&type=script&lang=js"

import "./VPARecall.vue?vue&type=style&index=0&id=e1ea0a16&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e1ea0a16"]])

export default __exports__